import { useContext } from 'react'

import { Log, MileageLossCode, RouteSelectionMode } from '@/types/logs'
import { Context } from '../context'
import { useCombinedLogsTableFormStateStore } from '../store'

export const useCreateBulkCurtailment = (log: Log) => {
    const { form, setIsCreateFormActive } = useContext(Context)
    const { setIsBulkCurtailmentLog, setRoute } = useCombinedLogsTableFormStateStore()

    const handleCreateBulkCurtailment = () => {
        setIsCreateFormActive(true)
        const routes =
            log.routeSelectionMode !== RouteSelectionMode.None && log.routes.length === 1 ? log.routes.at(0) : undefined

        form &&
            form.reset({
                code: MileageLossCode.OND,
                routes:
                    log.routeSelectionMode !== RouteSelectionMode.None && log.routes.length === 1
                        ? log.routes.at(0)
                        : undefined,
                description: 'Bulk curtailment',
                eventLogId: log.id,
            })

        if (routes) {
            setRoute(routes)
        }

        setIsBulkCurtailmentLog(true)

        const tableEl = document.querySelector<HTMLDivElement>(`div[data-scrollable-table]`)

        tableEl && tableEl.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return {
        handleCreateBulkCurtailment,
    }
}
